import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class WarehouseExportService {
  private baseUrl = '/api/inventory/inventory_csv_export_v2.php';

  constructor(private http: HttpClient) {}

  /**
   * Downloads a warehouse CSV report
   * @param report Report type (e.g. 'warehouse_overview')
   * @param warehouseUuid Warehouse UUID (optional)
   * @param contactUuid Contact UUID (optional)
   * @param customFileName Optional filename override (without .csv)
   */
  downloadCsv(
    report: string,
    warehouseUuid?: string,
    contactUuid?: string,
    customFileName?: string
  ): void {
    const params: any = { report };
    if (warehouseUuid) params.warehouse_uuid = warehouseUuid;
    if (contactUuid) params.contact_uuid = contactUuid;
    if (customFileName) params.dl = customFileName;

    this.http.get(this.baseUrl, { params, responseType: 'blob' }).subscribe({
      next: blob => {
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
        const filename = `${customFileName || report}_${timestamp}.csv`;
        saveAs(blob, filename);
      },
      error: err => console.error('Warehouse export failed:', err)
    });
  }
}